import {useDataFormContext, useDataFormValidationContext} from '../contexts';

/**
 * Whether validation errors should be evaluated and displayed for a field.
 * Errors are shown when all errors are shown for the form, or when the field
 * has been visited, unless validation is turned off via DataFormNoValidation.
 */
export const useShowFieldErrors = (visited: boolean): boolean => {
  const {showErrors} = useDataFormContext();
  const validate = useDataFormValidationContext();

  return validate && (showErrors || visited);
};
